import {
  DatePicker,
  Flex,
  Icon,
  InputItem,
  List,
  SegmentedControl,
  Toast,
} from "antd-mobile";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import update from "immutability-helper";
import { formatNumber } from "../util";

export interface OrderCollection {
  collectionDate: any;
  remitCompany: string;
  amount: string;
}

interface sixProps {
  defaultValues?: OrderCollection[];
  defaultType?: number;
  total: string;
}

const isIPhone = new RegExp("\\biPhone\\b|\\biPod\\b", "i").test(
  window.navigator.userAgent
);
let moneyKeyboardWrapProps: object | undefined;
if (isIPhone) {
  moneyKeyboardWrapProps = {
    onTouchStart: (e: { preventDefault: () => any }) => e.preventDefault(),
  };
}

const StepSix = forwardRef(
  ({ defaultValues, defaultType, total }: sixProps, ref: any) => {
    const [collectionType, setCollectionType] = useState<number>(0);
    const [data, setData] = useState<OrderCollection[]>([
      { collectionDate: "", remitCompany: "", amount: "" },
      { collectionDate: "", remitCompany: "", amount: "" },
    ]);

    useEffect(() => {
      window.scrollTo(0, 0);
      if (defaultValues && defaultValues.length > 0) {
        setData(defaultValues);
      }
      if (defaultType) {
        setCollectionType(defaultType);
      }
    }, [defaultValues, defaultType]);

    const add = useCallback(() => {
      const newData = [...data];
      newData.push({ collectionDate: "", remitCompany: "", amount: "" });
      setData(newData);
    }, [data]);

    const del = useCallback(
      (index) => {
        const newData = [...data];
        newData.splice(index, 1);
        setData(newData);
      },
      [data]
    );

    const onChangeDate = useCallback(
      ({ date }, index) => {
        setData(
          update(data, {
            [index]: {
              collectionDate: {
                $set: date,
              },
            },
          })
        );
      },
      [data]
    );
    const onChangeRemit = useCallback(
      (value, index) => {
        setData(
          update(data, {
            [index]: {
              remitCompany: {
                $set: value,
              },
            },
          })
        );
      },
      [data]
    );

    const onChangeAmount = useCallback(
      (value, index) => {
        setData(
          update(data, {
            [index]: {
              amount: {
                $set: formatNumber(value),
              },
            },
          })
        );
      },
      [data]
    );

    useImperativeHandle(ref, () => ({
      getData: () => {
        if (collectionType === 1) {
          let sum: number = 0;
          data.forEach((item: { amount: string }) => {
            sum += parseFloat(item.amount);
          });
          if (sum !== parseFloat(total)) {
            Toast.info("还款金额总和应等于实收总额", 1);
            return false;
          }
          return data;
        } else {
          return true;
        }
      },
      getType: () => {
        return collectionType;
      },
    }));

    return (
      <>
        <div className="mt45"></div>
        <div style={{ lineHeight: "40px", padding: "0 20px" }}>到款方式</div>
        <div style={{ background: "#f2f2f2", padding: "5px 20px 10px" }}>
          <SegmentedControl
            values={["全部到款", "分批到款"]}
            selectedIndex={collectionType}
            onChange={(e) => {
              setCollectionType(e.nativeEvent.selectedSegmentIndex);
            }}
          />
        </div>
        {collectionType === 1 && (
          <>
            {data.length > 0 &&
              data.map((item, index) => (
                <List key={"service" + index}>
                  <Flex
                    justify="between"
                    style={{ background: "#f2f2f2", padding: "10px 20px" }}>
                    <Flex.Item>批次{index + 1}</Flex.Item>
                    <Flex.Item style={{ textAlign: "right", color: "#999" }}>
                      {index > 1 ? (
                        <Icon
                          type="cross-circle"
                          size={"xxs"}
                          onClick={() => del(index)}
                        />
                      ) : (
                        ""
                      )}
                    </Flex.Item>
                  </Flex>
                  <DatePicker
                    mode="date"
                    title="选择日期"
                    value={item.collectionDate}
                    onChange={(date) => onChangeDate({ date }, index)}>
                    <List.Item arrow="horizontal">预计到款日期</List.Item>
                  </DatePicker>
                  <InputItem
                    placeholder="请输入"
                    value={item.remitCompany}
                    onChange={(value) => onChangeRemit(value, index)}>
                    汇款单位
                  </InputItem>
                  <InputItem
                    placeholder="请输入"
                    value={item.amount}
                    type="money"
                    moneyKeyboardWrapProps={moneyKeyboardWrapProps}
                    onChange={(value) => onChangeAmount(value, index)}>
                    还款金额
                  </InputItem>
                </List>
              ))}
            <div className="space"></div>
            <div className="addShopBtn" onClick={add}>
              + 添加批次
            </div>
            <div className="space"></div>
          </>
        )}
      </>
    );
  }
);

export default StepSix;
